import { PhoneType, Tag } from "@/schema"
import { v4 as uuidv4 } from "uuid"
import { create } from "zustand"

export interface ProspectFormData {
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneExtension: string
  phoneType: PhoneType
  createMore: boolean
  createOpportunity: boolean
  opportunityPipelineId: string
  opportunityStageId: string
  opportunityValue: number | null
  opportunityTargetCloseDate: string | null
  opportunityOwnerId: string | null
  opportunityCustomFieldValues: Record<string, unknown>
  opportunityLabel: Tag | null
  bookId?: string
}

interface ProspectStore {
  drafts: Record<string, ProspectFormData>
  createDraft: (defaultValues?: Partial<ProspectFormData>) => string
  updateDraft: (id: string, updates: Partial<ProspectFormData>) => void
  removeDraft: (id: string) => void
}

const createDefaultDraft = (): ProspectFormData => {
  const targetCloseDate = new Date()
  targetCloseDate.setMonth(targetCloseDate.getMonth() + 1)

  return {
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    phoneExtension: "",
    phoneType: "mobile",
    createMore: false,
    createOpportunity: false,
    opportunityPipelineId: "",
    opportunityStageId: "",
    opportunityValue: null,
    opportunityTargetCloseDate: targetCloseDate.toISOString(),
    opportunityOwnerId: null,
    opportunityCustomFieldValues: {},
    opportunityLabel: null,
  }
}

export const useProspectStore = create<ProspectStore>((set) => ({
  drafts: {},
  createDraft: (defaultValues?: Partial<ProspectFormData>) => {
    const id = uuidv4()
    set((state) => ({
      drafts: {
        ...state.drafts,
        [id]: { ...createDefaultDraft(), ...defaultValues },
      },
    }))
    return id
  },
  updateDraft: (id, updates) => {
    set((state) => {
      if (!state.drafts[id]) return state

      return {
        drafts: {
          ...state.drafts,
          [id]: {
            ...state.drafts[id],
            ...updates,
          },
        },
      }
    })
  },
  removeDraft: (id) => {
    set((state) => {
      const newDrafts = { ...state.drafts }
      delete newDrafts[id]
      return { drafts: newDrafts }
    })
  },
}))
